export const trainers = [
  {
    name: "Deependra Singh Chauhan",
    qualification: "B.Ed,L.L.B",
    subject: "English",
    vision: "Make learn English easy for students.",
    skill:"30 years’ experience of teaching English literature and grammar.",
    message: "Arise awake and stop not till the goal is reached.",
    comment: "I wish that this academy will become a milestone in the field of online learning.",
    image: "assets/img/trainers/1.jpg"
  },
  {
    name: "Ankit Sharma",
    qualification: "M. Tech. (Design Engineering)",
    subject: "Physics",
    vision: "“However slow you are, never stop moving towards right direction.” ",
    skill: "Working as an Engineer, New Product Development Dept.(ARB Bearings Ltd.)",
    image: "assets/img/trainers/2.JPG",
    message: "Building concepts of students instead of rote learning will always make India, ‘Atmanirbhar’ (self reliant) one day.",
    comment: "It is a very bright opportunity these people have invested their resources in. Taking a mission of ‘Quality First’ will surely help students through the platform. Good luck."
  },
  {
    name: "Rishabh Patel",
    subject: "Mechanics, Mathematics",
    vision: "Research work in astronomy and being a good teacher.",
    image: "assets/img/trainers/7.jpg"
  },
]; 

export const AllTrainers = [
  {
    name: "Deependra Singh Chauhan",
    qualification: "B.Ed,L.L.B",
    subject: "English",
    vision: "Make learn English easy for students.",
    skill:"30 years’ experience of teaching English literature and grammar.",
    message: "Arise awake and stop not till the goal is reached.",
    comment: "I wish that this academy will become a milestone in the field of online learning.",
    image: "assets/img/trainers/1.jpg"
  },
  {
    name: "Vishvendra Pratap Singh",
    qualification: "Ph.D (persuing)",
    subject: "Chemistry",
    vision: `To provide best quality of education to all our students. To teach in a way
    that students should treat leaning as fun not as a burden.`,
    skill:"Researcher and mechanical engineering",
    message: `We all have seen that last six months were very challenging
    for all. A transition in our modern education system is in process after new
    educational policy has been announced. Also due to COVID, way of teaching has
    also changed. Now online classes are the primary mode of education system.
    Therefore, for all students it is important to adjust themselves according to these
    changes. I hope with my online lectures, students can learn from home. I shall also
    try to discuss how students can adjust themselves with this new education system
    and online learning during my lectures. Wish all students good luck and successful
    life ahead.`,
    comment: `It is a great initiative by our team. It is a
    perfect time to launch an online learning academy. I hope we all as a team achieve
    all our goals and provide quality education to our students.`,
    image: "assets/img/trainers/10.jpg"
  },
  {
    name: "Shweta Singh",
    qualification: "MSc CHEMISTRY",
    subject: "CHEMISTRY",
    vision: "EDUCATION IS THE MOST POWERFUL WEAPON WHICH YOU CAN USE TO CHANGE THE WORLD",
    skill:"Good communication , teamwork, problem solving",
    message: "PRACTICE MAKES A MAN PERFECT. SO, PRACTICE, PRACTICE AND PRACTICE.",
    comment: "INNOVATIVE IDEA TO EXCEL IN EDUCATION",
    image: "assets/img/trainers/5.jpg"
  },
  {
    name: "Ankit Sharma",
    qualification: "M. Tech. (Design Engineering)",
    subject: "Physics",
    vision: "“However slow you are, never stop moving towards right direction.” Hobbies/Special Interest: Muscle cars, Reading about defense technical advancements and knowledge about engines.",
    skill: "Working as an Engineer, New Product Development Dept.(ARB Bearings Ltd.)",
    image: "assets/img/trainers/2.JPG",
    message: "Building concepts of students instead of rote learning will always make India, ‘Atmanirbhar’ (self reliant) one day.",
    comment: "It is a very bright opportunity these people have invested their resources in. Taking a mission of ‘Quality First’ will surely help students through the platform. Good luck."
  },
  {
    name: "Rishabh Patel",
    qualification: "B.tech( mechanical engineering), M.tech.(Design)",
    subject: "Mechanics, Mathematics",
    vision: "Research work in astronomy and being a good teacher.",
    skill:"Good communication , teamwork, problem solving",
    message: "Enjoy the journey, don’t run for finish line.",
    comment: "All the best guys.",
    image: "assets/img/trainers/7.jpg"
  },
  {
    name: "Rohit Jain",
    qualification: "Integrated B.Tech.(Mechanical Engineering) + M.Tech.(Design Engineering)",
    subject: "Mathematics",
    vision: "",
    skill:"AutoCad, Solidworks, Ansys",
    message: "Enjoy the journey, don’t run for finish line.",
    comment: "All the best guys.",
    image: "assets/img/trainers/rr.jpeg"
  },
  {
    name: "Dwarka Prasad",
    qualification: "B.tech & M.tech",
    subject: "Mathematics",
    vision: "Wants to become best faculty for maths and maximum students will score 90+ marks in maths",
    skill:"to teach math with best tricks to make easiest for student",
    message: `I will provide you best methods for every topic in maths which will
    help you to competitive exam and higher education.`,
    comment: `This is the best platform for students which provide online classes for each subject for class 1-12th. Here all faculty are fully dedicated to their
    field. As a faculty of ARA Learning Academy I will give my best to our students.`,
    image: "assets/img/trainers/3.jpg"
  },{
    name: "Rajendra Mishra",
    qualification: "Int. B. Tech + M.tech (Machine Design)",
    subject: "Mechanics",
    vision: `Our Mission is to provide high quality education and childcare in a
    safe, respectful and inclusive environment that builds a foundation for life-
    long learning.`,
    skill:"communication, leadership, problem solving, decision making.",
    message: `Do not give up no matter what, always try just one more
    time, and eventually you will be successful.`,
    comment: `It’s the platforms that focus on basis
    knowledge first...`,
    image: "assets/img/trainers/6.jpg"
  },{
    name: "Gauri Singh",
    qualification: "B.Tech (Biotechnology)",
    subject: "Biology",
    vision: `I am an ambitious, determined, and hard-working girl chasing my
    dreams and willing to work with best of my abilities. The most important thing
    for us is to believe in ourselves and to always work hard to bring out the best
    version of ourselves.`,
    skill:"Working as a Biologist, prominent at Java and MySQL, good at communication.",
    message: `Never give up your own thoughts and perspective
    regarding any concept because each one of us is unique and thus have unique
    thoughts. Always believe in you.`,
    comment: `The academy aims at serving the
    students with quality education to enhance their skills and knowledge. The
    academy offers the students to gain necessary knowledge and then combine it
    with their own ideas and thoughts to achieve their goals.`,
    image: "assets/img/trainers/4.jpg"
  },  
]; 

export const Advisor = [
  {
    name: "Dr. Nagendra Singh",
    qualification: "PhD,AIIMS",
    skill:"20 years’ experience of research and teaching in government organizations.",
    message: `Students are future of society/nation and the world therefore
    you have got a serious responsibility on your shoulder to build a strong character
    by learning of inside and of the outside environment.`,
    comment: `Learning is mostly depends on the learner and a teaching is
    meant only to facilitate learning by the students. Student learning is a function of both formal and
    informal experiences. Formal learning takes place as a result of a classroom or related activity structured
    by a teacher and/or others for the purpose of helping students to achieve specified cognitive, or other,
    objectives. Informal learning encompasses all the other outcomes of students participation in a higher
    education experience. The future teaching and learning process belongs to the development of easier
    methods for facilitating learning of students using online ways. I am glad that ARA Learning Academy
    has started a student’s centered learning approach for online teaching. Looking at the potential of the
    individuals involved in this venture I am sure that ARA academy will touch epitome of success in the
    future ahead.`,
    image: "assets/img/trainers/ns.jpg"
  },
  {
    name: "Vaishali Gurjar",
    qualification: "MTech/BEd",
    skill:"6 years teaching experience of Chemistry and Biology.",
    message: `Students must know importance of raising questions in the
    class room and also outside. That is fundamental to great learning.`,
    comment: `As far I understand ARA learning Academy is going to be the
    future of online teaching and learning. They have got strong and hard working people to lead the teaching
    process. I wish them great luck in this initiative.`,
    image: "assets/img/trainers/vs.jpg"
  }
]